<span [hidden]="isListItemsLoaded()"
  ><em>Loading List Items...</em></span
  >
  <span [hidden]="!isListItemsLoaded()">
    <mat-select
      matInput
      placeholder="{{ setting.PropertyName }}"
      [required]="setting.Mandatory"
      [(ngModel)]="additionalValues[setting.PropertyName]"
      name="additional_{{ setting.PropertyName }}"
      id="additional_{{ setting.PropertyName }}"
      >
      @for (val of listItems; track val) {
        <mat-option
          [value]="val.Value"
          >
          {{ val.Text }}
        </mat-option>
      }
    </mat-select>
  </span>
